import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import { trackSelfDescribingEvent } from '@snowplow/browser-tracker'

type SeachContextOverrideParams = Omit<Partial<comluxgroup.Search_1_0_0>, 'searchParams'> & { searchParams: Partial<comluxgroup.Search_1_0_0['searchParams']>}

const SEARCH_CATEGORY = 'searchFilters'

export function buildSearchContext(override?: SeachContextOverrideParams) {
  return {
    verticals: [],
    searchBar: '',
    searchType: '',
    searchSessionId: '',
    searchResults: [],
    ...override,
    searchParams: {
      landmarkId: null,
      propertyId: null,
      destinationId: null,
      checkIn: null,
      checkOut: null,
      isFlexibleDates: false,
      occupancies: [],
      sort: {
        isPristine: true,
      },
      filters: {
        holidayTypes: [],
        locations: [],
        amenities: [],
      },
      ...override?.searchParams,
    },
  }
}

function mapToSnowplowFilters(existingFilters: App.OfferListFilters): comluxgroup.Search_1_0_0['searchParams']['filters'] {
  return {
    holidayTypes: existingFilters.holidayTypes ?? [],
    locations: existingFilters.locations ?? [],
    amenities: existingFilters.amenities ?? [],
    propertyTypes: existingFilters.propertyTypes ?? [],
  }
}

export enum FrontPageEvent {
  FILTERS_APPLIED = 'FILTERS_APPLIED',
  FILTERS_RESET = 'FILTERS_RESET',
  MAP_VIEW_OPENED = 'MAP_VIEW_OPENED',
  LIST_VIEW_OPENED = 'LIST_VIEW_OPENED',
}

const eventsMap: Record<FrontPageEvent, comluxgroup.ClientEvent_1_0_0> = {
  FILTERS_APPLIED: {
    action: 'applied',
    subject: 'offerListFilters',
    type: 'interaction',
    category: SEARCH_CATEGORY,
  },
  FILTERS_RESET: {
    action: 'reset',
    subject: 'offerListFilters',
    type: 'interaction',
    category: SEARCH_CATEGORY,
  },
  MAP_VIEW_OPENED: {
    action: 'clicked',
    subject: 'mapViewButton',
    type: 'interaction',
    category: SEARCH_CATEGORY,
  },
  LIST_VIEW_OPENED: {
    action: 'clicked',
    subject: 'listViewButton',
    type: 'interaction',
    category: SEARCH_CATEGORY,
  },
}

export function trackFrontPageClientEvent(eventType: FrontPageEvent, existingFilters?: App.OfferListFilters) {
  const uiSearchContext = comluxgroup.createSearch_1_0_0(buildSearchContext({
    searchBar: 'secondaryFilter',
    searchType: 'offerListFilters',
    searchParams: {
      filters: existingFilters ? mapToSnowplowFilters(existingFilters) : undefined,
    },
  }))
  trackSelfDescribingEvent({
    context: [uiSearchContext],
    event: comluxgroup.createClientEvent_1_0_0(eventsMap[eventType]),
  })
}
